<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-half">
        <!-- 저장 -->
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>

        <div class="box">
          <admin-box-item title="노트 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="*노트 제목">
                  <input class="input"
                         style="width:250px"
                         :value="value.title"
                         @input="e=> value.title = e.target.value"
                         type="text">
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="*노트 내용">
                  <lp-editor :text.sync="value.content"></lp-editor>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LpEditor from "../../../module/common/LpEditor";
  import GroupMixin from "@/mixins/GroupMixin"

  export default {
    mixins: [
      GroupMixin
    ],
    components: {
      LpEditor
    },
    data() {
      return {
        showFile: false,
        board_id: 0,
        post_id: 0,
        value: {
          title:'',
          content:''
        }
      }
    },
    created() {
      this.post_id = this.$route.query.post_id;
      this.board_id = this.$route.query.board_id;
      this.getData();
      if(this.post_id) {
        this.getComment();
      }
    },
    computed: {
      pBackground() {
        return {
          backgroundColor: '#000000',
          opacity: '0.3',
          width: '100%',
          height: '100%',
          top: '0',
          left: '0',
          position: 'fixed',
          zIndex: '1101'
        }
      },
      pBarStyle() {
        return {
          top: '50%',
          left: '50%',
          position: 'fixed',
          zIndex: '1101',
          transform: 'translate(-50%, -50%)'
        }
      }
    },
    methods: {
      getData() {
        if(this.post_id) {
          this.$axios.get(this.getUrl(`group/board/base/${this.board_id}/post/${this.post_id}`)).then(res=>{
            this.value = res.data;
            this.showFile = true;
          })
        }
      },
      saveData() {
        if(!this.value.title) {
          this.toast('제목을 입력하세요.');
          return;
        }
        if(!this.value.content) {
          this.toast('내용을 입력하세요.');
          return;
        }

        // this.$store.commit('setLoading', true);
        if(this.post_id) {
          this.$axios.patch(this.getUrl(`group/board/base/${this.board_id}/post/${this.post_id}`), this.value)
            .then(res=>{
              if(res.status===200) {
                // this.$store.commit('setLoading', false);
                this.toast('저장되었습니다.');
                this.$router.replace(this.getPath(`group/board/base/post?board_id=${this.board_id}`));
              }
          }).catch(error=>{
            // this.$store.commit('setLoading', false);
            this.percentCompleted=0;
            this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
          })
        }
        else {
          this.$axios.post(this.getUrl(`group/board/base/${this.board_id}/post`), this.value).then(res=>{
            if(res.status===200) {
              // this.$store.commit('setLoading', false);
              this.percentCompleted=0;
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath(`group/board/base/post?board_id=${this.board_id}`));
            }
          }).catch(error=>{
            // this.$store.commit('setLoading', false);
            this.percentCompleted=0;
            this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
          })
        }
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

</style>
